import React from 'react';
import { formatDateTime, formatTime, getFormattedDeliveryWindowList } from '@dataGrid/gridUtilities';
import EtaEtdRenderer from '../../../modules/IBPlanning/RoutesView/EtaEtdRenderer';

const getServiceWindowContent = (params) => {
  return getFormattedDeliveryWindowList(params).map((deliverySlot, index) => (
    <React.Fragment key={index}>
      <span>{deliverySlot}</span>
      <br />
    </React.Fragment>
  ));
};

const getPopupContent = ({ params, infoData, planDate }) => {
  const serviceWindow = getServiceWindowContent(params);
  return [
    {
      labels: ['Service Window'],
      labelClass: 'firstTableCell',
      values: [serviceWindow],
      valueClass: 'firstTableCell'
    },
    {
      labels: ['ETA'],
      values: [
        <EtaEtdRenderer
          key="eta"
          params={{
            data: { eta: infoData.eta },
            valueFormatted: formatTime({ value: infoData.eta }),
            context: { planDate: planDate }
          }}
          fieldName="eta"
        />
      ]
    },
    {
      labels: ['Weight', 'PSE'],
      values: [`${infoData.totalWeight} lbs`, infoData.pse]
    },
    { labels: ['Bills'], values: [infoData.bills] },
    ...(infoData.stopIbeta
      ? [
          {
            labels: ['Max IB ETA'],
            values: [formatDateTime({ value: infoData.stopIbeta })]
          }
        ]
      : []),
    ...(infoData.specialInstruction
      ? [
          {
            labels: ['Special Instructions'],
            labelClass: 'nameCellPadding',
            values: [infoData.specialInstruction],
            showTooltip: true
          }
        ]
      : [])
  ];
};

export { getPopupContent };
